export const events = {
  Sc_Client_List: "cpr-salescredit-client-list--order-changed",
  Sc_Client_Profitability: "cpr-salescredit-client-profitability--changed",
  Sc_Interactive_Chart: "cpr-salescredit-interactive-chart--config-changed",
  Nbi_Interactive_Chart_Prtfolio:
    "cpr-nbi-interactive-chart--portfolio--config-changed",
  Nbi_Interactive_Chart: "cpr-nbi-interactive-chart--config-changed",
};
